(() => {
  if (window.Sn26MediaStrip) {
    window.Sn26MediaStrip.init(document);
    return;
  }
  const instances = new Map();
  const init = scope => {
    const roots = scope.matches?.('[data-sn26-media-strip]') ? [scope] : scope.querySelectorAll('[data-sn26-media-strip]');
    roots.forEach(root => {
      if (instances.has(root)) return;
      const group = root.querySelector('[data-sn26-source]');
      const track = root.querySelector('[data-sn26-track]');
      const viewport = root.querySelector('.sn26-media-strip__viewport');
      if (!group || !track || !viewport) return;
      const originals = Array.from(group.children);
      const fillers = [];
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      let clone = null;
      let viewportWidth = 0;
      const decorate = node => {
        node.setAttribute('aria-hidden', 'true');
        node.setAttribute('inert', '');
        node.removeAttribute('data-shopify-editor-block');
        node.querySelectorAll('[id]').forEach(child => child.removeAttribute('id'));
        node.querySelectorAll('[data-shopify-editor-block]').forEach(child => child.removeAttribute('data-shopify-editor-block'));
        return node;
      };
      const syncMotion = () => {
        clone?.remove();
        clone = null;
        fillers.splice(0).forEach(node => node.remove());
        const enabled = root.dataset.animate === 'true' && !reduced.matches && originals.length > 1;
        root.classList.toggle('is-animated', enabled);
        viewportWidth = viewport.getBoundingClientRect().width;
        if (enabled) {
          const baseWidth = group.getBoundingClientRect().width;
          const repeats = Math.min(20, Math.max(1, Math.ceil(viewportWidth / Math.max(1, baseWidth))));
          for (let repeat = 1; repeat < repeats; repeat++) {
            originals.forEach(original => {
              const filler = decorate(original.cloneNode(true));
              filler.setAttribute('data-sn26-fill', '');
              fillers.push(filler);
              group.append(filler);
            });
          }
          const speed = Math.min(60, Math.max(20, Number(root.dataset.speed) || 30));
          root.style.setProperty('--sn26-runtime-duration', `${group.getBoundingClientRect().width / speed}s`);
          clone = decorate(group.cloneNode(true));
          clone.removeAttribute('data-sn26-source');
          clone.setAttribute('data-sn26-clone', '');
          track.append(clone);
        }
      };
      const resize = new ResizeObserver(() => {
        if (Math.abs(viewport.getBoundingClientRect().width - viewportWidth) > 1) syncMotion();
      });
      reduced.addEventListener('change', syncMotion);
      instances.set(root, () => {
        reduced.removeEventListener('change', syncMotion);
        resize.disconnect();
        clone?.remove();
        fillers.forEach(node => node.remove());
        root.classList.remove('is-animated');
      });
      syncMotion();
      resize.observe(viewport);
    });
  };
  const destroy = scope => {
    instances.forEach((cleanup, root) => {
      if (scope === root || scope.contains(root)) { cleanup(); instances.delete(root); }
    });
  };
  window.Sn26MediaStrip = { init, destroy };
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => destroy(event.target));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  else init(document);
})();
